/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface GetLoyaltyPoints200Response
 */
export interface GetLoyaltyPoints200Response {
    /**
     * 
     * @type {number}
     * @memberof GetLoyaltyPoints200Response
     */
    points?: number;
}


/**
 * Check if a given object implements the GetLoyaltyPoints200Response interface.
 */
export function instanceOfGetLoyaltyPoints200Response(value: object): boolean {
    let isInstance = true;
    return isInstance;
}

export function GetLoyaltyPoints200ResponseFromJSON(json: any): GetLoyaltyPoints200Response {
    return GetLoyaltyPoints200ResponseFromJSONTyped(json, false);
}

export function GetLoyaltyPoints200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLoyaltyPoints200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'points': !exists(json, 'points') ? undefined : json['points'],
    };
}

export function GetLoyaltyPoints200ResponseToJSON(value?: GetLoyaltyPoints200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'points': value.points,
    };
}

